import { $ } from '@/libs/jquery/index'

$.validator.addMethod('phone', function(value: string, element: HTMLElement): boolean {
  const parsed = value.replace( /\(|\)|\s+|-/g, '')

  return this.optional(element) || parsed.length > 9 && /^((\+7|7|8)+([0-9]){10})$/.test(parsed)
}, 'Укажите верный номер')
